module.exports = __webpack_public_path__ + "img/p3.37d0478d.png";